module.exports = __webpack_public_path__ + "img/watage_4.c582bb7e.png";